
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { IAPILoginUser } from '@hokify/common';
import { getSupportPhone } from '@hokify/shared-components/lib/helpers/contact-info';

const loginStore = namespace('login');
const userProfile = namespace('user/profile');

@Component({
	name: 'CookieHeader'
})
export default class CookieHeader extends Vue {
	supportPhone = getSupportPhone(this.$store.state.topLevelDomain);

	@loginStore.State('loggedIn') loggedIn;
	@userProfile.State('obj') user!: IAPILoginUser;
}
